(() => {
  const root = document.querySelector('[data-lynk-scent-root]');
  if (root) {
    root.addEventListener('click', (event) => {
      const link = event.target.closest('[data-lynk-scent-track]');
      if (!link) return;
      document.dispatchEvent(new CustomEvent('lynk:scent-select', { detail: link.dataset }));
    });
  }
  document.querySelectorAll('[data-lynk-scent-products]').forEach((grid) => {
    const buttons = [...grid.querySelectorAll('[data-lynk-format]')];
    const products = [...grid.querySelectorAll('[data-lynk-product-format]')];
    const status = grid.querySelector('[data-lynk-filter-status]');
    buttons.forEach((button) => button.addEventListener('click', () => {
      const format = button.dataset.lynkFormat;
      let visible = 0;
      buttons.forEach((item) => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
      products.forEach((product) => {
        const matches = format === 'all' || product.dataset.lynkProductFormat === format;
        product.hidden = !matches;
        if (matches) visible += 1;
      });
      if (status) status.textContent = `${visible} product${visible === 1 ? '' : 's'} shown`;
    }));
  });
  const revealTargets = [...document.querySelectorAll('[data-lynk-reveal]')];
  if (revealTargets.length) {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      revealTargets.forEach((el) => el.classList.add('is-visible'));
    } else {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
      revealTargets.forEach((el) => io.observe(el));
    }
  }
})();
